module.exports = __webpack_public_path__ + "img/usuario_sin_acces_white_1.de06b999.png";